export const unhex = str => str.substring(str.indexOf('#') + 1)
